import { render, staticRenderFns } from "./GmzHqsjfxTable.vue?vue&type=template&id=bc628bbc&"
import script from "./GmzHqsjfxTable.vue?vue&type=script&lang=js&"
export * from "./GmzHqsjfxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports